module.exports = __webpack_public_path__ + "media/images/logo-coachconnect-e0dfd324c4ff661bcd91dea51d8388d5.png";